import { Grid, TextField, Box, Typography, Alert } from '@mui/material';

export function LoginCredentialsStep({ formik }) {
  return (
    <Box>
      <Alert severity="info" sx={{ mb: 3 }}>
        These credentials will be used by the teacher to log into the ERP system. An email will be sent with these details once created.
      </Alert>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Login Email (Username)"
            name="loginEmail"
            type="email"
            value={formik.values.loginEmail || formik.values.email} // Default to contact email
            onChange={formik.handleChange}
            error={formik.touched.loginEmail && Boolean(formik.errors.loginEmail)}
            helperText={formik.touched.loginEmail && formik.errors.loginEmail}
            required
          />
        </Grid>
        
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Password"
            name="password"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            required
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
            helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
            required
          />
        </Grid>
      </Grid>
    </Box>
  );
}
